import { render, staticRenderFns } from "./ApexoTable.vue?vue&type=template&id=6e2fc49d&"
import script from "./ApexoTable.vue?vue&type=script&lang=js&"
export * from "./ApexoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports